export default __webpack_public_path__ + "static/media/drop-filter.3dfc1f5d.svg";